"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gameHeight_1 = __importDefault(require("../constants/gameHeight"));
const gameWidth_1 = __importDefault(require("../constants/gameWidth"));
const ZIndexType_1 = __importDefault(require("../enums/ZIndexType"));
const state_1 = __importDefault(require("../state"));
const drawImage_1 = __importDefault(require("./draw/drawImage"));
const drawRectangle_1 = __importDefault(require("./draw/drawRectangle"));
const drawText_1 = __importDefault(require("./draw/drawText"));
const drawLevelCompleteHUD = () => {
    const nextZIndex = {
        value: 10000,
        type: ZIndexType_1.default.Hard
    };
    const x = 110;
    const height = 81;
    const y = gameHeight_1.default / 2 - height / 2;
    (0, drawRectangle_1.default)("#000000", .5, x, y, gameWidth_1.default - x * 2, height, 10000);
    (0, drawText_1.default)("Level Complete!", "#ffffff", gameWidth_1.default / 2, y + 6, 1, gameWidth_1.default, 1, "center", "top");
    const frameDuration = 65;
    const frame = Math.floor(state_1.default.currentTime % (frameDuration * 4) / frameDuration);
    (0, drawImage_1.default)("eating", 1, frame * 32, 0, 32, 26, gameWidth_1.default / 2 - 16, y + 19, 32, 26, nextZIndex);
    (0, drawImage_1.default)("buttons/next", 1, 0, 0, 47, 24, gameWidth_1.default / 2 - 24, y + 51, 47, 24, nextZIndex);
};
exports.default = drawLevelCompleteHUD;
